import { isEmpty, isObjectLike } from 'lodash';
import Logger from '@sm360/logger-sentry';
import { ConfigsService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';

class TradeInVehicleMapperService {
    constructor() {
        this.logger = new Logger('TradeInVehicleMapperService', ConfigsService.getLoggerContext());
    }

    /**
     * Convert a Vehicle to a tradeInVehicle.
     * @param {VehicleModel} vehicle
     * @returns {Object} TradeInVehicle
     */
    vehicleToTradeInVehicle(vehicle) {
        if (isEmpty(vehicle) || !isObjectLike(vehicle)) {
            this.logger.error('Error converting vehicleToTradeInVehicle. Argument `vehicle` is invalid.', { vehicle });
            return {};
        }
        return {
            id: vehicle.id,
            make: vehicle.make,
            model: vehicle.model,
            trim: vehicle.modelTrim,
            style: !isEmpty(vehicle.modelTrimStyle) ? vehicle.modelTrimStyle[0] : '',
            year: parseInt(vehicle.year, 10),
            odometer: parseInt(vehicle.odometer, 10),
            exteriorColor: !isEmpty(vehicle.bodyColour) ? vehicle.bodyColour.colorCode : '',
            vin: vehicle.vin,
        };
    }

    /**
     * Convert a TradeInVehicle to a VehicleModel.
     * @param {Object} TradeInVehicle
     * @returns {VehicleModel} Vehicle
     */
    tradeInVehicleToVehicle(tradeInVehicle) {
        if (isEmpty(tradeInVehicle) || !isObjectLike(tradeInVehicle)) {
            this.logger.error('Error converting tradeInVehicleToVehicle. Argument `tradeInVehicle` is invalid.', {
                tradeInVehicle,
            });
            return new Vehicle.VehicleModel();
        }
        return new Vehicle.VehicleModel({
            ...tradeInVehicle,
            bodyColour: { colorCode: tradeInVehicle.exteriorColor },
            year: parseInt(tradeInVehicle.year, 10),
            odometer: parseInt(tradeInVehicle.odometer, 10),
            modelTrim: tradeInVehicle.trim,
            modelTrimStyle: [tradeInVehicle.style],
        });
    }

    /**
     * Convert a TradeInVehicle to a TradeInVehicleLead.
     * @param {Object} TradeInVehicle
     * @returns {Object} TradeInVehicleLead
     */
    tradeInVehicleToVehicleLead(tradeInVehicle) {
        if (isEmpty(tradeInVehicle) || !isObjectLike(tradeInVehicle)) {
            this.logger.error('Error converting tradeInVehicleToVehicleLead. Argument `tradeInVehicle` is invalid.', {
                tradeInVehicle,
            });
            return {};
        }
        return {
            id: tradeInVehicle.id,
            make: tradeInVehicle.make,
            model: tradeInVehicle.model,
            // We need to concatenate the trim and style because the showroomAPI doesn't have the style property. They are splited in the widget-supplier
            modelTrimCode: `${tradeInVehicle.trim}|${tradeInVehicle.style}`,
            year: parseInt(tradeInVehicle.year, 10),
            odometer: parseInt(tradeInVehicle.odometer, 10),
            exteriorColor: tradeInVehicle.exteriorColor,
            vin: tradeInVehicle.vin,
        };
    }
}

export default new TradeInVehicleMapperService();
